/**
 * 加单模块韩文文案。키는 zh-CN와 일대일 대응。
 * 상태/액션 코드는 열거값을 그대로 키로 쓴다(reorder.status.REQUESTED 등).
 */
export default {
  reorder: {
    exportTooLarge: '내보낼 기록이 너무 많습니다. 브랜드 범위를 줄여 주세요. 불완전한 파일은 생성하지 않았습니다',
    deliveryRequired: '생산 확정 전에 납기를 입력해 주세요',
    workFactoryRequired: '생산 확정 전에 작업 공장을 선택해 주세요',
    source: {
      disabled: '판매·재고 자료 연동이 활성화되지 않았습니다', adminOnly: '관리자만 판매·재고 자료를 가져올 수 있습니다',
      invalidDate: '자료 기준일은 원천 날짜보다 늦을 수 없습니다', foreignBrand: '다른 브랜드의 스타일이 포함되어 있습니다',
      invalidBatch: '생산 차수가 중복되거나 해당 스타일이 아닙니다', incomplete: '원천 행 수와 유효·제외 행 수가 일치하지 않습니다',
      changedRun: '동일 원천 버전의 내용이 변경되었습니다. 확인 후 새 게시 버전을 사용해 주세요',
      stale: '이전 자료로 현재 자료를 덮어쓸 수 없습니다', foreignSnapshot: '해당 날짜에 다른 원천의 자료가 있습니다. 먼저 확인해 주세요',
      quantityOverflow: '수량이 지원 범위를 초과했습니다', invalidFile: '10MB 이하의 유효한 자료 파일을 선택해 주세요',
      styleSkuLimit: '한 스타일의 색상·사이즈 조합이 500개를 초과합니다. 원천 단위를 확인해 주세요',
      imported: '판매·재고 자료를 가져왔습니다', importTitle: '판매·재고 가져오기', chooseFile: '자사 분석 자료 파일 선택',
      importHint: '자사 분석에서 게시한 자료를 가져옵니다. 브랜드·기준일·행 수·누락 정보를 확인한 후 적용해 주세요.',
      manualHint: '판매·재고는 자사 분석 자료이며 추가 주문 수량은 직접 입력합니다. 없는 제안·공장·날짜는 추정하지 않습니다.',
      empty: '게시된 판매·재고 자료가 없습니다. 관리자가 확인한 후 가져와 주세요.',
      apply: '이 버전 가져오기', businessEnd: '자료 기준일', styleCount: '스타일 수', skuCount: '유효 사이즈 기록',
      excludedAxes: '색상·사이즈 누락 제외', missingStock: '재고 확인 필요', missingFactory: '공장 미확인 스타일',
      missingDate: '차수 날짜 미확인 스타일', stock: '판매 가능 재고', sales: '누적 판매', inbound: '누적 입고',
    },
    adjustmentAlreadyHandled: '이미 처리된 조정입니다.',
    adjustmentNotAllowed: '현재 상태는 조정할 수 없거나 처리 중인 조정이 있습니다.',
    adjustmentNotFound: '조정 요청을 찾을 수 없습니다.',
    adjustmentResponseInvalid: '조정 응답이 올바르지 않습니다.',
    adjustTypeInvalid: '조정 유형이 올바르지 않습니다.',
    dateFormat: '유효한 날짜를 입력하세요.',
    deliverySkuInvalid:
      '요청에 포함된 컬러·사이즈만 출고할 수 있으며 요청 수량을 초과할 수 없습니다.',
    itemsRequired: '유효한 상세 행을 한 개 이상 입력하세요.',
    brandRequired: '브랜드를 선택하세요.',
    acceptPConfirmedOnly: '생산 확정된 요청만 수주할 수 있습니다.',
    deliveryQtyRequired: '양수의 출고 수량을 입력하세요.',
    deliveryStatusInvalid: '공장 수주 후 출고할 수 있습니다.',
    fabricShortage: '원단 재고가 부족하여 수주할 수 없습니다.',
    factoryRequired: '작업 공장을 지정하세요.',
    stockQtyInvalid: '재고 수량은 양수여야 합니다.',
    stockReasonInvalid: '재고 이동 사유가 올바르지 않습니다.',
    stockShortage: '완제품 재고가 부족합니다.',
    adminOnly: '관리자만 실행할 수 있습니다.',
    duplicateSku: '동일한 컬러·사이즈를 중복 입력할 수 없습니다.',
    factoryAdminOnly: '공장 계정 연결이 완료되기 전에는 관리자만 실행할 수 있습니다.',
    notFound: '리오더 요청을 찾을 수 없습니다.',
    styleCodeRequired: '스타일 코드를 입력하세요.',
    brandNotAllowed: '해당 브랜드를 처리할 권한이 없습니다.',
    brandNotFound: '브랜드를 찾을 수 없습니다.',
    cancelPConfirmedOnly: '생산 확정 상태만 생산 확정을 취소할 수 있습니다.',
    deletedImmutable: '삭제된 요청은 수정할 수 없습니다.',
    deleteRequestedOnly: '확인 대기 요청만 삭제할 수 있습니다.',
    deliveryDateFormat: '유효한 납기를 입력하세요.',
    deliveryDateViaAdjustment: '현재 상태에서는 납기를 직접 수정할 수 없습니다. 조정을 요청하세요.',
    expectedRoundRequired: '유효한 예상 차수를 입력하세요.',
    factoryAlreadyAccepted: '공장이 이미 수주하여 생산 확정을 취소할 수 없습니다.',
    productionConfirmedOnly: '계획 확정 요청만 생산 확정할 수 있습니다.',
    roundAfterProduction: '생산 확정 후에는 예상 차수를 수정할 수 없습니다.',
    splitConfirmedOnly: '계획 확정 요청만 분할할 수 있습니다.',
    splitQtyRequired: '양수의 분할 수량을 입력하세요.',
    statusNotAllowed: '해당 업무 기능을 통해 상태를 변경하세요.',
    statusTransitionInvalid: '현재 상태에서는 이 작업을 실행할 수 없습니다.',
    vendorNotFound: '가공 업체를 찾을 수 없습니다.',
    vendorRequired: '가공 업체를 선택하세요.',
    vendorRequiredFirst: '가공 업체를 먼저 저장하세요.',
    workFactoryInvalid: '작업 공장이 해당 가공 업체에 속하지 않습니다.',
    workFactoryNotFound: '작업 공장을 찾을 수 없습니다.',
    status: {
      label: '상태',
      REQUESTED: '대기',
      CONFIRMED: '기획확정',
      AWAITING_APPROVAL: '조정 승인대기',
      P_CONFIRMED: '생산확정',
      FACTORY_CONFIRMED: '공장접수완료',
      PRODUCTION_COMPLETED: '납기완료',
      CANCELLED: '취소',
      DELETED: '삭제',
    },
    styleCode: '스타일',
    styleName: '스타일명',
    requester: '신청자',
    vendor: '임가공업체',
    factory: '작업공장',
    round: '차수(현재→예정)',
    totalQty: '발주량',
    totalAmount: '발주액',
    deliveryDate: '납기요청일',
    createdAt: '생성시각',
    colorCode: '칼라코드',
    colorName: '칼라명',
    sizeCode: '사이즈',
    suggestedQty: '제안수량',
    totalReorderQty: '전체기간제안',
    requestedQty: '신청수량',
    unitPrice: '단가',
    orderAmount: '금액',
    board: {
      title: '리오더 보드',
      desc: '주차별 제안량으로 리오더를 신청한다. 3색은 해당 주 수요를 가먼트 재고·원단 생산능력으로 감당할 수 있는지를 나타낸다.',
      dwNotConfigured:
        'DW 미설정 — 보드를 사용할 수 없습니다. 관리자가 DW_DATABASE_URL 설정 후 동기화하세요.',
      dwNoData: 'DW 설정 완료했으나 스냅샷이 없습니다. 첫 동기화 후 제안량이 표시됩니다.',
      searchPh: '스타일 / 품명 검색',
      snapshot: '데이터 스냅샷일 {d}',
      loadColors: '칼라 상세 펼치기',
      hqStock: '본사재고',
      weeklySales: '주판매',
      round: '차수',
      season: '시즌',
      planner: '기획',
      sellthrough: '선팔율',
      windowQty: 'sp={sp} 창구량',
      actions: '작업',
      request: '리오더 신청',
      hide: '숨기기',
    },
    requestDialog: {
      title: '리오더 신청 · {style}',
      manualStyle: 'DW에 없는 스타일 — 수기등록으로 생성되며 예정차수는 비어 있습니다.',
      sp: '보정판매기간(주)',
      vendor: '임가공',
      round: '현재차수',
      weekWindow: '창구제안량',
      windowHint: '창구 [W+{start}부터 {sp}주] — 납기나 sp를 바꾼 뒤 다시 계산할 수 있습니다.',
      recalc: '다시 계산',
      manualFlag: '수동수정',
      qtyRequired: '한 사이즈라도 0보다 큰 신청량을 입력하세요',
      reasonPh: '리오더 사유(선택)',
      total: '합계 {n}장',
      submit: '신청 제출',
      created: '리오더 신청이 생성되었습니다',
    },
    prod: {
      title: '생산확정',
      desc: '기획확정된 전표. 납기요청일·예정차수·임가공업체를 지정한 뒤 생산확정한다.',
      count: '생산확정 대기 {n}건',
      expectedRound: '예정차수',
      workFactory: '작업공장',
      readiness: '확정가능',
      ready: '확정가능',
      blocked: '보완필요',
      confirm: '생산확정',
      confirmTitle: '생산확정',
      confirmPrompt:
        '확정하면 「생산확정」 상태로 이동하며 납기와 차수가 잠깁니다. 계속하시겠습니까?',
      confirmed: '생산확정 완료',
      vendorMissing: '임가공업체 미지정',
      roundMissing: '예정차수 미저장',
      dateSaved: '납기요청일 갱신됨',
      roundSaved: '예정차수 저장됨',
      roundInvalid: '차수 형식이 올바르지 않습니다(두 자리 숫자, 예: 02)',
      vendorSaved: '임가공업체 갱신됨(작업공장 자동 추종)',
      saveRound: '저장',
    },
    history: {
      title: '리오더 이력',
      desc: '전체 리오더 신청과 소통 이력. 요약와 목록이 같은 기준으로 갱신된다.',
      includeDeleted: '삭제건 포함',
      export: 'Excel 내보내기',
      generatedAt: '요약 생성일 {d}',
      cardQty: '총 {n}장',
      noData: '리오더 데이터가 없습니다',
      itemsTitle: '사이즈 상세',
      timelineTitle: '소통 이력',
      showTimeline: '이력 펼치기',
      hideTimeline: '이력 접기',
    },
    action: {
      REQUEST_CREATED: '신청 생성',
      REQUEST_DELETED: '신청 삭제',
      STATUS_CHANGED: '상태 변경',
      DELIVERY_DATE_CHANGED: '납기요청일 변경',
      SUPPLIER_CHANGED: '임가공업체 변경',
      FACTORY_CHANGED: '작업공장 변경',
      EXPECTED_ROUND_CHANGED: '예정차수 변경',
      PRODUCTION_CONFIRMED: '생산확정',
      PRODUCTION_CANCELLED: '생산확정 취소',
      SPLIT_CREATED: '분배(공장할당)',
      FACTORY_CONFIRMED: '공장 접수',
      FACTORY_CONFIRM_ROLLBACK: '공장 접수 롤백',
      FABRIC_DEDUCTED: '원단 생산차감',
      ADJUSTMENT_REQUESTED: '공장 조정요청',
      ADJUSTMENT_CANCELLED: '공장 조정 철회',
      ADJUSTMENT_RESPONDED: '본사 조정 회신',
      DELIVERY_COMPLETED: '출하완료',
      HISTORY_RESTORED: '전표 복원',
    },
    error: {
      FABRIC_SHORTAGE: '원단 재고 부족으로 접수할 수 없습니다',
      STOCK_SHORTAGE: '가먼트 재고 부족',
      ACCEPT_P_CONFIRMED_ONLY: '「생산확정」 상태만 접수할 수 있습니다',
      DELETE_REQUESTED_ONLY: '「대기」 상태의 리오더만 삭제할 수 있습니다',
      DELIVERY_DATE_VIA_ADJUSTMENT:
        '현재 상태에서는 납기요청일을 직접 수정할 수 없습니다. 조정요청으로 처리하세요',
      ROUND_AFTER_PRODUCTION:
        '생산확정 후에는 예정차수를 수정할 수 없습니다. 생산확정을 먼저 취소하세요',
      DW_NOT_CONFIGURED: 'DW 미설정, 보드 데이터를 사용할 수 없습니다',
      BRAND_NOT_ALLOWED: '해당 브랜드에 대한 권한이 없습니다',
      FACTORY_ADMIN_ONLY: '공장 작업은 현재 관리자 전용입니다(공장 계정 체계 구축 후 개방)',
    },
  },
};
